import React from 'react'
import styles from "./style.scss"

export default function CommissionInfo({ commission_value }) {

  const calculatedCommission = {
    commission_rate: 10,
  }

  return (
    <div className={styles["commission_info"]}>
      <table>
        <tbody>
          <tr>
            <th>
              <span className={styles["bold"]}>
                Commission Rate
              </span><br />
              <span className={`${styles["link"]} ${styles["bold"]}`}>
                Payout details
              </span>
            </th>
            <td>
              <span className={styles["bold"]}>
                {commission_value}%<br />
              </span>
              on SP + GST
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  )
}
